{
  "GenericAdminFilterLanguage_CME_LABEL": "CME",
  "GenericAdminFilterLanguage_TELSYS_LABEL": "Telephony Server",
  "GenericAdminFilterLanguage_PARTITION_LABEL": "Partition",
  "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM Type",
  "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Include Child CME Items",
  "GenericAdminFilterLanguage_SEARCH_LABEL": "Search",
  "NAME": "GenericAdminFilterLanguage"
}